/*
 * GABY PARIS — Défilement infini des collections et de la recherche
 * Charge automatiquement la page suivante quand la cliente approche du bas de la grille.
 * Les liens de pagination restent dans le code (masqués) pour le référencement :
 * si le script ne se charge pas, la pagination classique réapparaît telle quelle.
 * Compatible avec les filtres et le tri en AJAX : tout est relu dans la page à chaque vérification.
 */
(function () {
  if (window.__gpDefilementInfini) return;
  window.__gpDefilementInfini = true;

  var css = document.createElement('style');
  css.textContent =
    '.gp-inf-masquee{display:none !important}' +
    '.gp-inf-chargement{display:flex;justify-content:center;padding:28px 0 8px;min-height:20px}' +
    '.gp-inf-chargement span{width:26px;height:26px;border:2px solid #DDD5C7;border-top-color:#828074;border-radius:50%;opacity:0}' +
    '.gp-inf-chargement.is-active span{opacity:1;animation:gpInfTourne .8s linear infinite}' +
    '@keyframes gpInfTourne{to{transform:rotate(360deg)}}';
  document.head.appendChild(css);

  var MARGE = 1500; // px avant le bas de la grille où l'on déclenche le chargement
  var enCours = false;
  var echecs = 0;

  function elements() {
    var racine = document.getElementById('CollectionAjaxContent');
    if (!racine) return null;
    var grille = racine.querySelector('.collection-grid__wrapper .grid--uniform');
    if (!grille) return null;
    return { racine: racine, grille: grille, pagination: racine.querySelector('.pagination') };
  }

  function urlSuivante(pagination) {
    if (!pagination) return null;
    var lien = pagination.querySelector('.next a');
    return lien ? lien.href : null;
  }

  function indicateur(grille) {
    var ind = grille.parentNode.querySelector('.gp-inf-chargement');
    if (!ind) {
      ind = document.createElement('div');
      ind.className = 'gp-inf-chargement';
      ind.setAttribute('aria-live', 'polite');
      ind.innerHTML = '<span></span>';
      grille.parentNode.insertBefore(ind, grille.nextSibling);
    }
    return ind;
  }

  function preparer(e) {
    if (e.pagination) e.pagination.classList.add('gp-inf-masquee');
  }

  function charger(e, url) {
    enCours = true;
    var ind = indicateur(e.grille);
    ind.classList.add('is-active');
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var racine = doc.getElementById('CollectionAjaxContent');
        var nouvelleGrille = racine && racine.querySelector('.collection-grid__wrapper .grid--uniform');
        if (!nouvelleGrille) throw new Error('grille introuvable');

        // La page a pu changer entre-temps (filtre, tri) : on vérifie qu'on complète toujours la même grille
        var actuel = elements();
        if (!actuel || actuel.grille !== e.grille) return;

        var frag = document.createDocumentFragment();
        while (nouvelleGrille.firstChild) frag.appendChild(document.adoptNode(nouvelleGrille.firstChild));
        e.grille.appendChild(frag);

        var nouvellePagination = racine.querySelector('.pagination');
        if (e.pagination) {
          if (nouvellePagination) {
            var adoptee = document.adoptNode(nouvellePagination);
            adoptee.classList.add('gp-inf-masquee');
            e.pagination.parentNode.replaceChild(adoptee, e.pagination);
          } else {
            e.pagination.parentNode.removeChild(e.pagination);
          }
        }
        echecs = 0;
        document.dispatchEvent(new CustomEvent('gp:produits-ajoutes'));
        // les photos du thème apparaissent en fondu (AOS) : on signale les nouvelles pièces,
        // sinon leurs images restent invisibles
        if (window.AOS && typeof window.AOS.refreshHard === 'function') {
          window.AOS.refreshHard();
        } else {
          e.grille.querySelectorAll('[data-aos]:not(.aos-animate)').forEach(function (el) {
            el.classList.add('aos-init', 'aos-animate');
          });
        }
      })
      .catch(function () {
        echecs++;
        // après deux échecs, on rend la pagination classique visible
        if (echecs >= 2) {
          var x = elements();
          if (x && x.pagination) x.pagination.classList.remove('gp-inf-masquee');
        }
      })
      .then(function () {
        ind.classList.remove('is-active');
        enCours = false;
        verifier();
      });
  }

  function verifier() {
    if (enCours) return;
    var e = elements();
    if (!e) return;
    preparer(e);
    if (echecs >= 2) return;
    var url = urlSuivante(e.pagination);
    if (!url) return;
    var bas = e.grille.getBoundingClientRect().bottom;
    if (bas - window.innerHeight < MARGE) charger(e, url);
  }

  var attente = null;
  function planifier() {
    if (attente) return;
    attente = setTimeout(function () {
      attente = null;
      verifier();
    }, 150);
  }

  window.addEventListener('scroll', planifier, { passive: true });
  window.addEventListener('resize', planifier);
  // après un filtre ou un tri en AJAX, le contenu est remplacé : on revérifie
  var obs = new MutationObserver(planifier);
  function observer() {
    var cible = document.getElementById('CollectionAjaxContent');
    if (cible) obs.observe(cible.parentNode || cible, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { observer(); verifier(); });
  } else {
    observer();
    verifier();
  }
  window.addEventListener('load', verifier);
  // filet de sécurité : si aucun événement de défilement n'arrive (position restaurée par le navigateur…), on revérifie chaque seconde
  setInterval(verifier, 1000);
})();
